import { object, array, number } from 'yup';
import { BundleConfig } from 'src/components/BundleProduct/types';

import { calculateQuantity } from './utils';
import { ColorAndSize } from './types';

export const getValidationSchema = (bundles: BundleConfig[], isCustomisationOptional: boolean) =>
    object().shape({
        bundles: array()
            .of(
                object()
                    .shape({
                        id: number(),
                        selectedColorsAndSizes: array().of(
                            object().shape({
                                colorId: number(),
                                sizes: array().of(
                                    object().shape({
                                        id: number(),
                                        quantity: number(),
                                    }),
                                ),
                            }),
                        ),
                    })
                    .test('maximum', `You've added too many items`, (values) => {
                        const config = bundles.find((bundle) => bundle.id === values.id);

                        if (!values || !config) return true;

                        return calculateQuantity(values.selectedColorsAndSizes as ColorAndSize[]) <= config.maxQty;
                    })
                    .test('minimum', 'Please add proper number of items', (values) => {
                        const config = bundles.find((bundle) => bundle.id === values.id);

                        if (!values || !config) return true;

                        return calculateQuantity(values.selectedColorsAndSizes as ColorAndSize[]) === config.maxQty;
                    }),
            )
            .required(),
        customisations: isCustomisationOptional
            ? array().notRequired()
            : array().test('length', 'Please add any customisation', (values) => values?.length !== 0),
    });
